//---------------------------------------------------

var swiper = new Swiper(".mySwiper-our-stores", {
  pagination: {
    el: ".swiper-pagination.pagi-our-stores",
    type: "progressbar",
  },
  navigation: {
    nextEl: ".swiper-button-next.btn-our-stores",
    prevEl: ".swiper-button-prev.btn-our-stores",
  },
  breakpoints: {
    325: {
      slidesPerView: 2,
      spaceBetween: 8,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 12,
    },
    1024: {
      slidesPerView: 6,
      spaceBetween: 16,
    },
  },
});

//---------------------------------------------------

var swiper = new Swiper(".mySwiper-the-look", {
  centeredSlides: true,
  initialSlide: 2,
  loop: true,
  pagination: {
    el: ".swiper-pagination.pagi-the-look",
    type: "progressbar",
  },
  navigation: {
    nextEl: ".swiper-button-next.btn-the-look",
    prevEl: ".swiper-button-prev.btn-the-look",
  },
  breakpoints: {
    325: {
      slidesPerView: 1.5,
      spaceBetween: 8,
    },
    768: {
      slidesPerView: 2.2,
      spaceBetween: 12,
    },
    1024: {
      slidesPerView: 3.3,
      spaceBetween: 16,
    },
  },
});

//---------------------------------------------------

var swiper = new Swiper(".mySwiper-related", {
  pagination: {
    el: ".swiper-pagination.pagi-related",
    type: "progressbar",
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    325: {
      slidesPerView: 1.2,
      spaceBetween: 8,
    },
    768: {
      slidesPerView: 2.2,
      spaceBetween: 12,
    },
    1024: {
      slidesPerView: 3.2,
      spaceBetween: 16,
    },
  },
});

//---------------------------------------------------

var swiper = new Swiper(".mySwiper-journal", {
  pagination: {
    el: ".swiper-pagination.pagi-journal",
    type: "progressbar",
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    325: {
      slidesPerView: 1.2,
      spaceBetween: 8,
    },
    768: {
      slidesPerView: 2.2,
      spaceBetween: 12,
    },
    1024: {
      slidesPerView: 3.2,
      spaceBetween: 16,
    },
  },
});

//---------------------------------------------------

var swiper = new Swiper(".mySwiper-why", {
  pagination: {
    el: ".swiper-pagination.pagi-why",
    type: "progressbar",
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    325: {
      slidesPerView: 2,
      spaceBetween: 8,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 12,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 16,
    },
  },
});

//---------------------------------------------------

var swiper = new Swiper(".mySwiper-product-drawer", {
  slidesPerView: 2.5,
  spaceBetween: 8,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next.btn-product-drawer",
    prevEl: ".swiper-button-prev.btn-product-drawer",
  },
});

//---------------------------------------------------

var swiper = new Swiper(".mySwiper-ss-col", {
  slidesPerView: "auto",
  navigation: {
    nextEl: ".swiper-button-next.btn-ss-col",
    prevEl: ".swiper-button-prev.btn-ss-col",
  },
  // breakpoints: {
  //   325: {
  //     slidesPerView: 3,
  //   },
  //   991: {
  //     slidesPerView: 5.5,
  //   },
  // },
});

//---------------------------------------------------

function setBannerTextState(slideEl, state) {
  if (!slideEl) return;

  var textBox = slideEl.querySelector(".txt-box");
  if (!textBox) return;

  textBox.classList.remove("is-banner-text-enter", "is-banner-text-exit");

  if (state === "enter") {
    textBox.classList.add("is-banner-text-enter");
  }

  if (state === "exit") {
    textBox.classList.add("is-banner-text-exit");
  }
}

function setBannerMediaState(slideEl, state) {
  if (!slideEl) return;

  slideEl.classList.remove("is-banner-media-enter", "is-banner-media-exit");

  if (state === "enter") {
    slideEl.classList.add("is-banner-media-enter");
  }

  if (state === "exit") {
    slideEl.classList.add("is-banner-media-exit");
  }
}

function syncBannerTextAnimation(swiper) {
  swiper.slides.forEach(function (slideEl) {
    var textBox = slideEl.querySelector(".txt-box");
    if (!textBox) return;

    if (slideEl.classList.contains("swiper-slide-active")) {
      textBox.classList.remove("is-banner-text-exit");
      textBox.classList.add("is-banner-text-enter");
      return;
    }

    textBox.classList.remove("is-banner-text-enter", "is-banner-text-exit");
  });
}

function syncBannerMediaAnimation(swiper) {
  swiper.slides.forEach(function (slideEl) {
    slideEl.classList.remove("is-banner-media-enter", "is-banner-media-exit");

    if (slideEl.classList.contains("swiper-slide-active")) {
      slideEl.classList.add("is-banner-media-enter");
    }
  });
}

var swiperban = new Swiper(".mySwiper-banner", {
  loop: true,
  speed: 1500,
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  autoplay: {
    delay: 6000,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    type: "progressbar",
    el: ".swiper-pagination.btn-id-banner",
  },
  on: {
    init: function (swiper) {
      syncBannerTextAnimation(swiper);
      syncBannerMediaAnimation(swiper);
    },
    slideChangeTransitionStart: function (swiper) {
      setBannerTextState(swiper.slides[swiper.previousIndex], "exit");
      setBannerTextState(swiper.slides[swiper.activeIndex], "enter");
      setBannerMediaState(swiper.slides[swiper.previousIndex], "exit");
      setBannerMediaState(swiper.slides[swiper.activeIndex], "enter");
    },
    slideChangeTransitionEnd: function (swiper) {
      syncBannerTextAnimation(swiper);
      syncBannerMediaAnimation(swiper);
    },
  },
});

//---------------------------------------------------

document.querySelectorAll(".mySwiper-op").forEach(function (el) {
  var section = el.closest(".tabcontent");
  if (!section) return;

  new Swiper(el, {
    breakpoints: {
      325: {
        slidesPerView: 2,
        spaceBetween: 8,
      },
      991: {
        slidesPerView: 4,
        spaceBetween: 12,
      },
    },
    pagination: {
      el: section.querySelector(".swiper-pagination.pagi-op"),
      type: "progressbar",
    },
    navigation: {
      nextEl: section.querySelector(".swiper-button-next.btn-op"),
      prevEl: section.querySelector(".swiper-button-prev.btn-op"),
    },
  });
});

//---------------------------------------------------

var swiper = new Swiper(".mySwiper-col-slide", {
  spaceBetween: 20,
  breakpoints: {
    325: {
      slidesPerView: 1,
    },
    991: {
      slidesPerView: 2,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next.btn-col-slide",
    prevEl: ".swiper-button-prev.btn-col-slide",
  },
  pagination: {
    el: ".swiper-pagination.pagi-col-slide",
    type: "progressbar",
  },
});

//---------------------------------------------------

var swiper = new Swiper(".mySwiper-col-detail", {
  loop: true,
  slidesPerView: 1,
  speed: 1500,
  pagination: {
    el: ".swiper-pagination.pagi-col-detail",
    type: "progressbar",
  },
  navigation: {
    nextEl: ".swiper-button-next.btn-col-detail",
    prevEl: ".swiper-button-prev.btn-col-detail",
  },
});

//---------------------------------------------------

var swiper = new Swiper(".mySwiper-story-fit", {
  breakpoints: {
    325: {
      slidesPerView: 2.2,
      spaceBetween: 12,
    },
    991: {
      slidesPerView: 4,
      spaceBetween: 16,
    },
  },
  pagination: {
    el: ".swiper-pagination.pagi-fit",
    type: "progressbar",
  },
});

//---------------------------------------------------

var swiper = new Swiper(".mySwiper-index-col", {
  breakpoints: {
    325: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 4,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next.btn-index-col",
    prevEl: ".swiper-button-prev.btn-index-col",
  },
});
